




















































import { Vue, Component } from "vue-property-decorator";

@Component
export default class ProfileComponent extends Vue {
  isLoading = false;
  oldPassword = "";
  newPassword = "";
  repeatPassword = "";
  async save() {
    const isValid = (this.$refs.validator as any).isValid();
    if (!isValid) return;
    this.isLoading = true;
    try {
      const res = await this.$api.AccountService.updatePasswordAsync({
        OldPassword: this.oldPassword,
        NewPassword: this.newPassword,
      });
      if (res) {
        this.$notification.success("Пароль успешно обновлен");
        this.oldPassword = "";
        this.newPassword = "";
        this.repeatPassword = "";
      }
    } catch (e) {
      this.$notification.error(e);
    }
    this.isLoading = false;
  }
}
